export const enumOrderSort = (a: { order: number }, b: { order: number }) => {
    const isNullish = (order) => order == null

    if (!(isNullish(a.order) || isNullish(b.order))) return a.order - b.order
    // prioritize items with a defined order
    if (!isNullish(a.order)) return -1
    if (!isNullish(b.order)) return 1

    return 0
}
